export default "__VITE_ASSET__Dpzpq5fM__"